module.exports = __webpack_public_path__ + "img/logo_symbol.4b5aaeba.png";